import React from "react";
import { connect } from "react-redux";
import {
  createDistrictNote,
  removeDistrictNote,
} from "../../../store/api/calls/doors";
import { setSessionVar } from "../../../store/actions";
import NoteModal from "./NoteModal";

class DistrictNoteModal extends React.Component {
  static defaultProps = {
    categories: [],
    notes: [],
    onCloseModal: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      refreshCounter: 0,
      bulkAddedNotes: [],
    };
  }

  componentWillUnmount() {
    this.props.hideModalAndUnsetDistrict();
  }

  onClose = () => {
    this.props.hideModalAndUnsetDistrict();
  };

  getNotes = () => {
    if (this.props.districts.length > 1) {
      return this.state.bulkAddedNotes;
    }
    return this.props.districts[0]?.notes || [];
  };

  getCategories = () => {
    return this.props.categories.filter((d) => d.for_doors);
  };

  getTitle = () => {
    if (this.props.districts.length > 1) {
      return `Add notes for ${this.props.districts.length} districts`;
    } else if (this.props.districts.length === 1) {
      return `Edit Notes for ${this.props.districts[0].name}`;
    }
  };

  onCreateNote = (category, note) => {
    const creationObj = {
      category,
      note,
      district_ids: this.props.districts.map((d) => d.id),
      doorcanvass_id: this.props.districts[0].doorcanvass_id,
    };

    createDistrictNote(creationObj)
      .then((data) => {
        let targetDistricts = this.props.districts;

        if (targetDistricts.length > 1) {
          this.setState({
            bulkAddedNotes: [...this.state.bulkAddedNotes, data[0]],
          });
        }

        targetDistricts = targetDistricts.map((targetDistrict) => {
          return {
            ...targetDistrict,
            notes: [
              ...(targetDistrict.notes || []),
              data.find((d) => d.district_id === targetDistrict.id),
            ],
          };
        });

        this.props.handleNoteCreateOrDestroy(targetDistricts);
      })
      .catch((err) => {
        console.log("DISTRICT NOTE ERROR", err);
      });
  };

  onRemoveNote = (note_id) => {
    removeDistrictNote(note_id).then(() => {
      let targetDistricts = this.props.districts;

      targetDistricts.map((targetDistrict) => {
        return {
          ...targetDistrict,
          notes: (targetDistrict.notes || []).filter((d) => d.id !== note_id),
        };
      });

      this.props.handleNoteCreateOrDestroy(targetDistricts);
    });
  };

  render() {
    return (
      <>
        {this.props?.districts?.length && (
          <div data-component="DistrictNoteModal">
            <NoteModal
              {...this.props}
              title={this.getTitle()}
              isOpen={typeof this.props.districts.length}
              onCloseModal={this.onClose}
              onCreateNote={this.onCreateNote}
              onRemoveNote={this.onRemoveNote}
              notes={this.getNotes()}
              refreshCounter={this.state.refreshCounter}
              loading={this.props.loading}
              categories={this.getCategories()}
              notDeletable={this.props.districts.length > 1}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.siteNotes.categories,
  districts: state.session.vars.districtNoteModalDistricts,
  loading: state.siteNotes.loading,
});

const mapDispatchToProps = (dispatch) => ({
  hideModalAndUnsetDistrict: () =>
    dispatch(setSessionVar("districtNoteModalDistricts", [])), //if set, modal visible. siteObj is null hides modal
});

export default connect(mapStateToProps, mapDispatchToProps)(DistrictNoteModal);
